import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

// Only Bold Industrial theme
export const theme = {
  id: 'industrial',
  name: 'Bold Industrial',
  typography: {
    headingFont: 'font-oswald',
    bodyFont: 'font-roboto',
    headingWeight: 'font-bold',
    headingTracking: 'tracking-tight',
  },
  colors: {
    background: 'bg-white',
    backgroundAlt: 'bg-slate-100',
    surface: 'bg-white',
    textPrimary: 'text-slate-900',
    textSecondary: 'text-slate-600',
    primary: 'bg-[#ff5218]',
    primaryHover: 'hover:bg-[#e54a15]',
    primaryText: 'text-[#ff5218]',
    accent: 'bg-[#21c2f8]',
    accentHover: 'hover:bg-[#1ba8d9]',
    accentText: 'text-[#21c2f8]',
    border: 'border-slate-300',
    navBg: 'bg-white/95',
  },
  layout: {
    container: 'max-w-7xl mx-auto px-6 md:px-12',
    sectionSpacing: 'py-20 md:py-28',
    radius: 'rounded-none',
  },
  components: {
    buttonPrimary: 'bg-[#ff5218] hover:bg-[#e54a15] text-white font-bold uppercase px-8 py-4 border-2 border-[#ff5218] hover:border-[#e54a15] transition-all duration-300',
    buttonSecondary: 'bg-[#21c2f8] hover:bg-[#1ba8d9] text-white font-bold uppercase px-8 py-4 border-2 border-[#21c2f8] transition-all duration-300',
    buttonOutline: 'border-2 border-[#ff5218] text-[#ff5218] hover:bg-[#ff5218] hover:text-white font-bold uppercase px-8 py-4 transition-all duration-300',
    card: 'bg-white border-2 border-slate-200 p-8 hover:border-[#ff5218] transition-colors duration-300',
    input: 'w-full px-4 py-3 bg-white border-2 border-slate-300 text-slate-900 focus:ring-2 focus:ring-[#ff5218] focus:border-transparent outline-none transition-all',
  },
};

export const ThemeProvider = ({ children }) => {
  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
